import { render, staticRenderFns } from "./clockBgc.vue?vue&type=template&id=d7834ade&scoped=true&"
import script from "./clockBgc.vue?vue&type=script&lang=js&"
export * from "./clockBgc.vue?vue&type=script&lang=js&"
import style0 from "./clockBgc.vue?vue&type=style&index=0&id=d7834ade&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7834ade",
  null
  
)

export default component.exports